import { render, staticRenderFns } from "./ListMerchants.vue?vue&type=template&id=03898b36"
import script from "./ListMerchants.vue?vue&type=script&lang=js"
export * from "./ListMerchants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports